function ok(data) {
  return Promise.resolve({ success: true, data })
}

// 根据指纹
export function getToken() {
  const token = sessionStorage.getItem('access_token') || 'mock-access-token'
  return ok(token)
}
